<template>
    <div v-if="loading" class ='slider'><div class ='line'></div><div class ='subline inc'></div><div class ='subline dec'></div></div>
    <div v-else class="dataInstructions_body_div">
        <div style="" class="databaseSummary_body_div">
            <div class="top_head">
<!--              <i class="iconfont icon-jianjie"></i>-->
              <h1>数据库简介
<!--                <a :href="'/api/downloadDocByDB?DB='+currentSystem.system" class="downloaddoc" title="点击下载">-->
<!--                  <i class="iconfont icon-jinghao"></i>-->
<!--                  下载说明书-->
<!--                </a>-->
              </h1>
            </div>
<!--            <div class="top_right" style="height:40px;float:right;line-height:40px;color:rgb(50, 121, 192);cursor:pointer;">-->
<!--              <div style="text-align: center;height: 30px">-->
<!--                <i class="iconfont icon-xiazai" style="font-size: 18px"></i>-->
<!--              </div>-->
<!--              <div style="position:relative;">-->
<!--                <a :href="'/api/downloadDocByDB?DB='+currentSystem.system" style="color: rgb(50, 121, 192)">下载说明书</a>-->
<!--              </div>-->
<!--&lt;!&ndash;              <a :href="'/api/downloadDocByDB?DB='+currentSystem.system"><img :src="'/img/ic_file_download_black_24px.svg'"></a>&ndash;&gt;-->
<!--            </div>-->
            <div class="summary_content_div" v-html="BaseInfo">

            </div>
        </div>
        <!-- <div class="databaseFeature_div" v-if="FeatureInfo">
            <div class="top_head" style="margin-bottom: 5px;">
                 <img src="/img/index/databaseFeature.png" />
                <span style="position:relative;top:2px;left:12px;">数据库特色</span>
            </div>
            <div class="databaseFeature_content_div" v-html="FeatureInfo">
            </div>
        </div> -->
        <div class="databaseContent_div" style="border-top: none">
            <div class="top_head">
              <h2><i class="iconfont icon-neirong" style="font-size: 18px;margin-right: 2px"></i> 数据库内容</h2>
            </div>
          <div class="databaseContent_table_div">
            <table class="databaseContent_table">
              <thead style="white-space: nowrap;">
              <tr>
                <th>
                  <span>项目</span>
                </th>
                <th>
                  <span>字段内容</span>
                </th>
                <th>
                  <span>数据起始时间</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in TableInfo" :key="index">
                <td style="white-space: nowrap;">{{item.DisplayName}}</td>
                <td>{{item.Fields}}</td>
                <td>{{item.DateRange}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
</template>
<script>
import axios from "../api/axios";
import { mapState } from "vuex";
export default {
    name:'DBIntro',
    data(){
        return{
            BaseInfo: '',
            FeatureInfo: '',
            loading: true
        }
    },
    computed:{
        ...mapState(["SystemList"]),
        currentSystem() {
            if(this.SystemList[this.$route.params.viewname]){
              console.log(this.SystemList[this.$route.params.viewname]);
              return this.SystemList[this.$route.params.viewname];
            }else{
                return {}
            }
        },
        TableInfo(){
          let sortedList = ['基本信息','词频统计','语调分析','可读性','相似性']
          let result = []
          if (this.$route.params.viewname === "CFND_HighTrail") {
            let companyTable = this.SystemList[this.$route.params.viewname].tableInfo;
            for (let tableInfoKey in companyTable) {
              result.push({
                DateRange: companyTable[tableInfoKey].StartDate ? companyTable[tableInfoKey].StartDate : "暂无",
                DisplayName: companyTable[tableInfoKey].ViewName,
                Fields: companyTable[tableInfoKey].fields ? companyTable[tableInfoKey].fields.map(s => s.DisplayName).join(',') : companyTable[tableInfoKey].Fields.map(s => s.DisplayName).join(',')
              })
            }
          } else {
            const heads = [];
            Object.keys(this.SystemList[this.$route.params.viewname].tableInfo).forEach((items => {
                heads.push(items.substring(items.indexOf("-") + 1, items.length));
            }))
            const database = this.currentSystem.system;
            for (let i = 0; i < heads.length; i++) {
              var tablekey = database+"-"+heads[i];
              if(this.currentSystem["tableInfo"].hasOwnProperty(tablekey)){
                var table = this.currentSystem["tableInfo"][tablekey]
                if(table.hasYear) {
                  result.push({
                    DateRange:table.startyear,
                    DisplayName:table.name,
                    Fields:table.fields.map(s=>s.title).join(',')})
                }else {
                  result.push({
                    DateRange:'暂无',
                    DisplayName:table.name,
                    Fields:table.fields.map(s=>s.title).join(',')})
                }
              }
            }
          }

          result = result.sort(function(a, b){  
            let  ret = sortedList.indexOf(a.DisplayName) - sortedList.indexOf(b.DisplayName)
            return ret;
          })
            return result
        }
    },
    watch: {
        '$route'(to, from) {
            this.init()
        }
    },
    mounted: function () {
        this.init()
    },
    methods: {
        init() {
            axios
            .get("/api/getDBIntroByDB?DB="+encodeURIComponent(this.currentSystem.system))
            .then(response => {
                this.BaseInfo = response.data.data.home_Base_Cn
                this.FeatureInfo = response.data.data.home_Feature_Cn
                this.loading = false;
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    }
}
</script>
<style scoped>
.panel {
    background-color: transparent;
}
.dataInstructions_body_div{
    margin: 0 auto;
}

.top_head {
    line-height: 40px;
    font-size: 16px;
}
.top_head h1{
  margin: 12px 0px;
  margin-bottom: 0px;
  font-size: 26px;
  font-weight: 400;
  color: #4773bb;
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
}
.downloaddoc{
  font-size: 14px;
  color: rgb(199 209 229);
  height: 28px;
  vertical-align: bottom;
  display: inline-block;
  width: 100px;
  text-align: center;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */
  -ms-transition: ease all 0.4s; /* Opera */
  margin-right: -5px;
}
.downloaddoc:visited,.downloaddoc:focus{
  text-decoration: none;
  color: #4773bb;
}
.downloaddoc i{
  vertical-align: bottom;
  margin-right: -5px;
}
.downloaddoc:hover{
  color: #2d8cf0;
  border-color: transparent;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */

}

.summary_content_div {
  margin-bottom: 30px;
}
.summary_content_div /deep/ #info-title {
  line-height: 36px;
  padding-left: 6px;
  font-size: 15px;
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
}
.summary_content_div /deep/ h2 {
  margin: 12px 0px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 400;
  color: #4773bb;
  background: #f9faff;
  height: 36px;
  line-height: 36px;
  padding-left: 12px;
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.summary_content_div /deep/ h2:before {
  content: "\e861";
  font-size: 18px;
  margin-right: 7px;
}
.summary_content_div /deep/ .info-content {
  font-size: 14px;
  margin: 0 40px 6px 40px;
}
.summary_content_div /deep/ .info-content {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: default;
}
.summary_content_div /deep/ .info-content:before {
  content: "\e622";
  font-size: 20px;
  vertical-align: middle;
  margin-left: -28px;
  margin-right: 6px;
  color: #ecf2fe;
  opacity: 1;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */

}
.summary_content_div /deep/ .info-content:hover::before {
  color: #4184f3;;
  transition: ease all 0.4s;
  -webkit-transition: ease all 0.4s; /* Safari and Chrome */
  -moz-transition: ease all 0.4s; /* Firefox */
  -ms-transition: ease all 0.4s; /* Opera */

}
.summary_title_div {
    height: 40px;
    text-align: center;
    font-size: 18px;
    line-height: 40px;
}

.downInstructions_button_div {
    width: 124px;
    height: 40px;
    margin: 0 auto;
    color: white;
    background-color: #2d73b9;
    font-size: 16px;
    text-align: center;
    margin-top: 35px;
    line-height: 40px;
    cursor: pointer;
}

h2 {
  margin: 12px 0px;
  font-size: 18px;
  font-weight: 400;
  color: #4773bb;
  background: #f9faff;
  height: 36px;
  line-height: 36px;
  padding-left: 14px;
}
.databaseContent_div {
    height: 660px;
}

.databaseContent_table_div {
  max-height: 530px;
  margin: 10px 13px;
}
.databaseContent_table thead{
  background: #fafafa;
}
.databaseContent_table td,.databaseContent_table th{
  border: 1px solid rgba(223, 229, 240, 0.8);
  padding: 10px 28px;
  text-align: left;
  color: #515a6e!important;
  vertical-align: middle;
  padding-right:45px;
  line-height: 1.6rem;
}

.databaseContent_head_table {
    width: 718px;
    height: 30px;
    position: absolute;
    z-index: 10;
    font-size: 14px;
}

.databaseContent_head_table th {
    border-right: 1px rgba(223, 229, 240, 0.8) solid;
}

.databaseContent_body_table_div {
    max-height: 498px;
    overflow: auto;
    position: relative;
    margin-top: 30px;
}

.databaseContent_body_table {
    width: 100%;
    background-color: white;
}

.databaseContent_body_table tr {
    height: 30px;
    border-bottom: 1px rgba(223, 229, 240, 0.8) solid;
    border-right: 1px rgba(223, 229, 240, 0.8) solid;
}

.databaseContent_body_table td {
    height: 30px;
    border-right: 1px rgba(223, 229, 240, 0.8) solid;
}

.databaseFeature_div {
    width: 720px;
    margin-top: 5px;
}

.databaseFeature_content_div {
    margin: 0 auto;
}

.databaseWarning_div {
    width: 100%;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
    padding: 5px 0px;
}
</style>
